import styled from 'styled-components'
import { blueDark, textMuted } from '@/theme/colors'
import { fontMono } from '@/theme/fonts'
import { radii } from '@/theme/tokens'
import { fontSizes, leading } from '@/theme/typography'
import { Button } from '@components/Button'

/** Styles for the timeline on the admin user-detail page. */

export const FeedHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	flex-wrap: wrap;
	margin-bottom: 16px;
`

export const SortButton = styled(Button).attrs({ variant: 'secondary' as const, size: 'sm' as const })``

/** Wraps the table so a wide payload column scrolls sideways instead of the page. */
export const FeedTableWrap = styled.div`
	overflow-x: auto;
`

export const EventTypeCell = styled.span`
	font-weight: 700;
	color: ${blueDark};
`

/** The collapsed one-line payload preview — truncated rather than wrapped. */
export const PayloadPreview = styled.span`
	display: inline-block;
	max-width: 352px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	vertical-align: bottom;
	font-family: ${fontMono};
	font-size: ${fontSizes.caption};
	color: ${textMuted};
`

/** The expanded payload, pretty-printed across the full row width. */
export const PayloadBlock = styled.pre`
	margin: 0;
	padding: 10px 12px;
	border-radius: ${radii.small};
	background-color: ${textMuted}14;
	font-family: ${fontMono};
	font-size: ${fontSizes.micro};
	line-height: ${leading.body};
	color: ${blueDark};
	white-space: pre-wrap;
	overflow-wrap: anywhere;
`

export const FeedNote = styled.p`
	margin: 0 0 16px;
	font-size: ${fontSizes.small};
	line-height: ${leading.body};
	color: ${textMuted};
`

/** Marks a row read from the domain tables rather than sent as an app event. */
export const SourceTag = styled.span`
	display: inline-block;
	margin-left: 8px;
	padding: 2px 8px;
	border-radius: ${radii.small};
	background-color: ${textMuted}22;
	color: ${textMuted};
	font-size: ${fontSizes.micro};
	font-weight: 700;
	vertical-align: middle;
`

/** A record's summary, truncated like a payload preview so a long comment can't stretch the table. */
export const RecordSummary = styled.span`
	display: inline-block;
	max-width: 352px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	vertical-align: bottom;
`
